import React, { memo } from 'react';

import BaseModal from '../BaseModal';

import './index.css';

const EmployeeInfoModal = (props) => {
  const { employee } = props;
  const body = (
    <div className="info-modal">
      <h2 className="info-modal__title">{employee.firstName + ' ' + employee.lastName}</h2>
      <p className="info-modal__row">
        <span className="info-modal__label">First Name</span>
        <span className="info-modal__value">{employee.firstName}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Last Name</span>
        <span className="info-modal__value">{employee.lastName}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Email</span>
        <span className="info-modal__value">{employee.email}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Phone</span>
        <span className="info-modal__value">{employee.phone}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Street Address</span>
        <span className="info-modal__value">{employee.address}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Zip</span>
        <span className="info-modal__value">{employee.zip}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Role</span>
        <span className="info-modal__value">{employee.role}</span>
      </p>
      <p className="info-modal__row">
        <span className="info-modal__label">Status</span>
        <span className="info-modal__value">{employee.status}</span>
      </p>
    </div>
  )

  return (
    <BaseModal 
      onClose={props.onClose}
      body={body}
    />
  );
}

export default memo(EmployeeInfoModal);